var Vendd = (function (Vendd) {
    'use strict';
    
    Vendd.Plugins = (function (Plugins) {

        Plugins.Messages = (function (Messages) {

            Messages.RecaptcaLoaded = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Plugins.Messages.RecaptcaLoaded', null);
            };
            Messages.RecaptcaLoaded.className = 'Vendd.Plugins.Messages.RecaptcaLoaded';

            Messages.GoogleMapsLoaded = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Plugins.Messages.GoogleMapsLoaded', null);
            };
            Messages.GoogleMapsLoaded.className = 'Vendd.Plugins.Messages.GoogleMapsLoaded';

            return Messages;

        })(Plugins.Messages || {});

        return Plugins;

    })(Vendd.Plugins || {});

return Vendd;

})(Vendd || {});